import { Button } from "@studyplus/boron-ui";
import { Field, Form, FormikBag, FormikProps, withFormik } from "formik";
import * as React from "react";
import { ApiErrorInterface } from "../../../interfaces/ApiErrorResponseInterface";
import {
  KarteTemplateFormInterface,
  KarteTemplateInterface,
} from "../../../interfaces/KarteTemplateInterface";
import Input from "../../atoms/Input/index";
import Textarea from "../../atoms/Textarea/index";
import { ApiErrors } from "./ApiErrors";
import { DeleteButton } from "./DeleteButton";
import { FormError } from "./FormError";
import styles from "./styles.scss";
import validationSchema from "./validationSchema";

export enum KarteTemplateFormType {
  Edit,
  New,
}

interface ComponentProps {
  type: KarteTemplateFormType;
  sectionId: string;
  karteTemplate: KarteTemplateInterface | null;
  submitting: boolean;
  loading: boolean;
  apiErrors: ApiErrorInterface[];
  onSubmit: (values: Values) => void;
  onDelete?: () => void;
}

type Props = ComponentProps & FormikProps<Values>;
type Values = KarteTemplateFormInterface;

const KarteTemplateForm: React.FC<Props> = (props) => {
  const handleDeleteBtn = () => {
    if (
      props.onDelete &&
      props.karteTemplate &&
      window.confirm("このテンプレートを削除してよろしいですか")
    ) {
      props.onDelete();
    }
  };

  const shouldRenderError = (name: string) => {
    const errors = (props.errors as any)[name];
    const touched = (props.touched as any)[name];
    return errors && touched;
  };

  return (
    <Form className={styles.root}>
      <div className={styles.name}>
        <div className={styles.label}>
          <label htmlFor="karte_template__name">テンプレート名</label>
          <FormError
            name="name"
            errors={props.errors as Record<string, string>}
            touched={props.touched as Record<string, boolean>}
          />
        </div>
        <Field
          id="karte_template__name"
          name="name"
          placeholder="テンプレート名を入力"
          component={Input}
          hasError={shouldRenderError("name")}
        />
      </div>
      <div className={styles.template}>
        <div className={styles.label}>
          <label htmlFor="karte_template__template">本文</label>
          <FormError
            name="template"
            errors={props.errors as Record<string, string>}
            touched={props.touched as Record<string, boolean>}
          />
        </div>
        <Field
          id="karte_template__template"
          name="template"
          component={Textarea}
          placeholder="本文を入力"
          rows="20"
          hasError={shouldRenderError("template")}
        />
      </div>
      <ApiErrors errors={props.apiErrors} />
      <div className={styles.footer}>
        <div>
          {props.type === KarteTemplateFormType.Edit && props.karteTemplate && (
            <DeleteButton
              submitting={props.submitting}
              onDelete={handleDeleteBtn}
            />
          )}
        </div>
        <div>
          <Button
            disabled={props.submitting || !props.isValid}
            type="submit"
            className={styles.button}
          >
            {props.type === KarteTemplateFormType.Edit ? "更新" : "登録"}
          </Button>
        </div>
      </div>
    </Form>
  );
};

const mapPropsToValues = (props: ComponentProps): Values => {
  if (props.karteTemplate) {
    return {
      name: props.karteTemplate.name,
      template: props.karteTemplate.template,
    };
  } else {
    return { name: "", template: "" };
  }
};

const handleSubmit = (
  values: Values,
  formikBag: FormikBag<ComponentProps, Values>,
) => {
  if (formikBag.props.submitting) {
    return;
  } else {
    formikBag.props.onSubmit(values);
  }
};

export default withFormik({
  mapPropsToValues,
  handleSubmit,
  validationSchema,
})(KarteTemplateForm);
